import styled, { css } from "styled-components";

const UnnamedComponent = (props) => (
  <AlertDiv {...props}>{props.children}</AlertDiv>
);

export default UnnamedComponent;

export const AlertDiv = styled.div`
  background-color: #ff00576e;
  border-radius: 3px;
  border: 1px solid #ff0057;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 14px;

  ${(props) =>
    props.$absolute &&
    css`
      border-radius: 6px;
      border: 2px dashed black;
      bottom: -20px;
      font-size: 14px;
      padding: 10px;
      position: absolute;
      transform: translateY(100%);
    `};

  ${(props) =>
    props.$info
      ? css`
          background-color: #ffffff;
          border-color: #313131;
          color: #383838;
        `
      : props.$success
        ? css`
            background-color: #edfffd;
            border-color: #009688;
            color: #009688;
          `
        : css`
            background-color: #ffe2e5;
            border-color: #f64e60;
            color: #f64e60;
          `};
`;
